import "./CostSourceFormulas.css";

import Draggable from "react-draggable";

import KsprButton from "components/UI/buttons/KsprButton";
import { copyToClipboard } from "core/clipboard_utils";

const CostSourceFormulas = (props) => {
	const strFormulas = props.data.row?.quantityformula;
	const event = props.data.event;

	if (strFormulas == null) return;
	if (!strFormulas.length) return;

	return (
		<Draggable handle=".CostSourceFormulasHeader">
			<div className="CostSourceFormulas" style={{ top: event.clientY, left: event.clientX }}>
				<div className="CostSourceFormulasHeader">Формула</div>
				<div className="CostSourceFormulasBody">{strFormulas}</div>
				<div className="CostSourceFormulasFooter">
					<KsprButton variant="text" label="Копировать" onClick={() => copyToClipboard(strFormulas)} />
					<KsprButton variant="text" label="Закрыть" onClick={props.f_closeBox} />
				</div>
			</div>
		</Draggable>
	);
};

export default CostSourceFormulas;
